<template>
  <div>
    <DataTable :value="fiscalyearLists" :paginator="true" :rows="10" :filters="filters"
               class="p-datatable-responsive p-datatable-gridlines">
      <Column header="S.N">
        <template #body="sl">
          {{ sl.index + 1 }}
        </template>
      </Column>
      <Column header="Name" filterMatchMode="contains" :sortable="true" field="name" filterField="name">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['name']"/>
        </template>
      </Column>
      <Column header="Start Date" field="startDate" :sortable="true" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['startDate']"/>
        </template>
      </Column>

      <Column header="Start Date Nepali" field="startDateNepali" :sortable="true" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['startDateNepali']"/>
        </template>
      </Column>
      <Column header="End Date" field="endDate" :sortable="true" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['endDate']"/>
        </template>
      </Column>
      <Column header="End Date Nepali" field="endDateNepali" :sortable="true" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['endDateNepali']"/>
        </template>
      </Column>
      <Column header="Txn Start Date" field="transactionStartDate" :sortable="true" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['transactionStartDate']"/>
        </template>
      </Column>
      <Column header="Txn Start Nepali" field="transactionDateNepali" :sortable="true" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['transactionDateNepali']"/>
        </template>
      </Column>
      <Column header="Active Fiscal Year" field="currentFiscalYear" filterMatchMode="contains">
        <template #body="slotProps">
          {{ slotProps.data.currentFiscalYear ? 'Yes' : 'No' }}
        </template>
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['currentFiscalYear']"/>
        </template>
      </Column>
      <Column header="Action" headerStyle="width:10em">
        <template #body="slotProps">
          <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                  @click="editFiscalYear(slotProps.data)"/>
          <Button icon="pi pi-trash" class="p-button-raised p-button-danger"
                  v-if="!slotProps.data.systemOnly"
                  @click="openDialog(slotProps.data.id)"/>
          <Button icon="pi pi-trash" class="p-button-raised p-button-danger" v-else
                  @click="openDialog(slotProps.data.id)" disabled/>
        </template>
      </Column>
    </DataTable>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteFiscalYear"/>
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'

export default {
  name: 'fiscalyearList',
  data() {
    return {
      dialogShow: false,
      fiscalYearId: '',
      filters: {}
    }
  },
  computed: {
    fiscalyearLists() {
      return this.$store.state.fiscalYearMaster.fiscalyearLists
    }
  },
  mounted() {
    this.fiscalyearList()
  },
  methods: {
    async fiscalyearList() {
      let resp = await this.$store.dispatch('loadFiscalYearList')
      console.log(resp)
    },
    async deleteFiscalYear(value) {
      if (value.trim() === '') {
        let message = {
          message: 'Delete Reason cannot be empty.',
          messageType: 'error'
        }
        this.$emit('delete-message', message)
        return
      }
      let deleteRe = {
        fiscalYearId: this.fiscalYearId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteFiscalYear', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        let message = {
          message: resp.data.message,
          messageType: 'success'
        }
        this.$emit('delete-message', message)
        this.closeDialog()
      } else {
        let message = {
          message: resp.data.message,
          messageType: 'warn'
        }
        this.$emit('delete-message', message)
        this.closeDialog()
      }
    },
    editFiscalYear(data) {
      this.$emit('edit-fiscalYear', data)
    },
    cancel(data) {
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.fiscalYearId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    InputText,
    Button
  }
}
</script>

<style>
.p-datatable table {
  border-collapse: collapse;
  width: 100%;
  table-layout: auto;
  column-gap: inherit;
}
</style>



// WEBPACK FOOTER //
// fiscalyearList.vue?4e5d52b3